import {combineReducers} from '@reduxjs/toolkit';

import {userBulkImportSlice} from '../user-bulk-import';

export const createUsersReducer = combineReducers({
    bulkImport: userBulkImportSlice.reducer,
});
